import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { ImageElement } from "../Components/Elements/Graphics/ImageElement";
import { Tweens } from "../Components/Effects/Tweens";
import { BaseElement } from "../Components/Elements/Graphics/BaseElement";

@engineComponent(ComponentTypes.DisplayObject)
export class Dolly extends ImageElement {
    private originPosition: PIXI.Point;

    create(node: Element): void {
        super.create(node);

        this.originPosition = new PIXI.Point(this.x, this.y);
    }

    public moveToPosition(position: PIXI.Point, duration: number = 30): void {
        if (position != null) {
            Tweens.removeTweens(this);
            Tweens.customTween(this, {
                tween: "position.x",
                tweenValues: [this.x, position.x],
                tweenDuration: [duration],
            });

            Tweens.customTween(this, {
                tween: "position.y",
                tweenValues: [this.y, position.y],
                tweenDuration: [duration],
            });
        }
    }

    public reset(): void {
        this.moveToPosition(this.originPosition, 0);
    }

    /**
     * Clone method used for cloning instance of this element with his main properties.
     * @method clone
     * @return ImageElement
     */
    clone(): Dolly {
        let element: Dolly = new Dolly();
        element.removeChildren();

        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.pivot.x = this.pivot.x;
        element.pivot.y = this.pivot.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.rotation = this.rotation;
        element.visible = this.visible;
        element.alpha = this.alpha;
        element.anchor = this.anchor;
        element.tint = this.tint;
        element.blendMode = this.blendMode;
        element.name = this.name;

        if (this.texture != null) {
            element.texture = this.texture;
        }

        if (this.maskSprite != null) {
            let elementMask = new PIXI.Sprite((<PIXI.Sprite>this.maskSprite).texture);
            elementMask.position.x = this.maskSprite.position.x;
            elementMask.position.y = this.maskSprite.position.y;

            element.maskSprite = elementMask;
            element.addChild(elementMask);
            element.mask = elementMask;
        }

        element.markAsCloned(); // must be called last before return!

        return element;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Dolly.ts
 **/